import { Input, InputProps } from "@mantine/core";
import { useModal } from "context/ModalStackManager";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { BarcodeInputForm } from "./barcodeInputForm";

interface InventoryBarcodeInputProps extends InputProps {
  // value: string
  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  handleBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  value: string;
  onChange: (value: string) => void;
}

export const MultiInventoryBarcodeInput = ({
  onKeyDown,
  handleBlur,
  onChange,
  value,
  ...etcParams
}: InventoryBarcodeInputProps) => {
  const { t } = useTranslation();
  const { openModal } = useModal();
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState(value);
  const [queuedValues, setQueuedValues] = useState<string[]>([]);
  const [isProcessingQueue, setIsProcessingQueue] = useState(false); // <-- 추가

  const handleConfirm = (values: string[]) => {
    if (values?.length > 0) {
      setQueuedValues(values);
    }
  };

  useEffect(() => {
    if (queuedValues.length > 0) {
      setIsProcessingQueue(true); // 큐 처리 시작 시 읽기 전용

      const processNextValue = async (index: number) => {
        if (index >= queuedValues.length) {
          setIsProcessingQueue(false); // 모두 처리 후 읽기 가능
          return;
        }

        const val = queuedValues[index];

        setInputValue(val);
        onChange(val);

        setTimeout(() => {
          if (inputRef.current) {
            const event = new KeyboardEvent("keydown", {
              key: "Enter",
              bubbles: true,
            });
            inputRef.current.dispatchEvent(event);
          }
        }, 50);

        setTimeout(() => {
          processNextValue(index + 1);
        }, 1000);
      };

      processNextValue(0);
    }
  }, [queuedValues]);

  useEffect(() => {
    if (inputRef.current && inputValue) {
      inputRef.current.value = inputValue;
    }
  }, [inputValue]);

  return (
    <Input.Wrapper size="1.4rem" label={t("바코드 정보 입력")} auto-focus>
      <Input
        value={value}
        readOnly={isProcessingQueue} // <-- 여기에 추가!
        onClick={() =>
          openModal(<BarcodeInputForm />, null, t("일괄 투입"), true).then(
            (result) => {
              handleConfirm(result);
            }
          )
        }
        onKeyDown={onKeyDown}
        aria-label="바코드정보"
        size="lg"
        data-autofocus
        ref={inputRef}
        placeholder="Enter Input And Take a Barcode"
        {...etcParams}
        onBlur={(e) => {
          etcParams.onBlur && etcParams.onBlur(e);
          handleBlur && handleBlur(e);
        }}
      />
    </Input.Wrapper>
  );
};
